import React from "react";
import { Typography } from "antd";
import type { OdReviewRunSummary } from "../../../services/odReview/odReview.types";

const { Text } = Typography;

interface RunCountersProps {
  run: OdReviewRunSummary;
  inline?: boolean;
}

const formatCost = (cost: number | null): string =>
  cost === null ? "sin dato" : `$${cost.toFixed(4)}`;

const RunCounters: React.FC<RunCountersProps> = ({ run, inline = false }) => {
  const entries = [
    ["Páginas leídas", String(run.pages_read ?? 0)],
    ["Páginas renderizadas", String(run.pages_rendered ?? 0)],
    ["Fotos revisadas", String(run.photos_reviewed ?? 0)],
    ["Referencias no verificables", String(run.unverifiable_references ?? 0)],
    ["Costo estimado", formatCost(run.estimated_cost_usd)],
  ];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: inline ? "row" : "column",
        flexWrap: "wrap",
        gap: inline ? 16 : 2,
      }}
    >
      {entries.map(([label, value]) => (
        <Text key={label} type="secondary" style={{ fontSize: 12 }}>
          {`${label}: ${value}`}
        </Text>
      ))}
    </div>
  );
};

export default RunCounters;
